import { useSelector } from "react-redux";

export const useIsAdmin = () => {
    const currentOrganisation = useSelector(
        (state) => state.organisation?.currentOrganisation
    );
    const userData = useSelector((state) => state.auth?.userData);
    const usersMap = currentOrganisation?.users ?? {};
    const roles = usersMap[userData?._id] ?? [];
    return Array.isArray(roles) && roles.includes("admin");
};

export default useIsAdmin;
